module.exports = __webpack_public_path__ + "img/logo.1ffe5706.png";